import React from 'react';
import { StripeFormProvider } from 'common/components/StripeForm/context';
import clientInfo from 'common/lib/clientInfo';
import { Frame, Toast, useSageBreakpoint } from '@kajabi/sage-react';

import { ExpiredSignupSourceAlert } from './components/ExpiredSignupSourceAlert';
import { Form } from './components/Form';
import { SignupInfo } from './components/SignupInfo';
import { AI_LEAD_GEN_ERROR_PARAM, AI_LEAD_GEN_ERROR_MSG } from './helpers/constants';

import { CheckoutProvider } from './context';

import './styles.scss';

const CheckoutContainer = () => {
  const breakpoints = useSageBreakpoint();
  const amount = clientInfo.get('amountToPayInCents');

  const queryParams = new URLSearchParams(window.location.search);
  const aiLeadGenError = queryParams.get(AI_LEAD_GEN_ERROR_PARAM);

  return (
    <StripeFormProvider amount={amount} skipBillingDetailsValidation={true}>
      <CheckoutProvider>
        <ExpiredSignupSourceAlert />
        <Frame
          align={Frame.ALIGNMENTS.TOP_CENTER}
          direction={Frame.DIRECTIONS[breakpoints.sm ? 'VERTICAL' : 'HORIZONTAL']}
          gap={Frame.GAPS.XL}
        >
          <Form />
          <SignupInfo />
          <Toast isActive={aiLeadGenError === 'true'} title={AI_LEAD_GEN_ERROR_MSG} />
        </Frame>
      </CheckoutProvider>
    </StripeFormProvider>
  );
};

export default CheckoutContainer;
